var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){return _vm.$emit('onClickTag', _vm.id)}}},[_c('span',{staticClass:"mr-2 bg-light p-2 mt-1",style:({backgroundColor: _vm.tagColor + ' !important'})},[_vm._v(" #"+_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }